
import { api_host} from '../../common/globals/constants';

export const getPass = (mail) => fetch(api_host+`/reporte/online/changepass/?mail=${mail}`)
.then(response => response.json())
